import React from 'react';
import { useHistory } from 'react-router'
import styles from './css/Error.module.css';
import { Row, Col, Button, Layout, Menu as AntdMenu } from 'antd';
import * as CONSTANTS from '../../constants/constants';
import * as Module from '../../modules/core/menuModule';
import { Footer } from "./CorePageContents";

const { Content } = Layout;

export const FreeMcdpIdError = () => {

  let history = useHistory();
  // ログアウト処理（閉じるボタン処理）
  async function logout() {
    try {
      // ログアウト処理を呼び出す
      await Module.logout();
    } catch (error) {
      // 処理なし
    } finally {
      // 利用終了画面に遷移
      history.push(CONSTANTS.PATH_USE_END);
      return <></>;
    }
   }

  return (
    <Layout>
      <Row className={styles.HeaderArea}>
        <Col span={6} className={styles.HeaderlogoArea}>
          <img
            className={styles.LogoStyle}
            src={process.env.PUBLIC_URL + '/header_logo_green.png'}
            alt="スキルマップサイト" />
        </Col>
      </Row>

      <AntdMenu className={styles.HeaderMenu}>
      </AntdMenu>

      <Content>
        <br />
        <br />
        <div className={styles.mainMessage}>ご利用のMCDP-IDをご確認ください</div>
        <br />
        <br />
        <div className={styles.subMessage}>
          平素は「スキルマップサイト」をご利用いただき、誠にありがとうございます。
          <br />
          <br />
          現在ログインされているMCDP-IDは、機能が制限された無償のMCDP-IDとなっております。<br />
          本サービスのすべての機能をご利用いただくには、有償のMCDP-IDが必要です。
          <br />
          <br />
          大変お手数ですが、貴社のシステムご担当者様にご確認いただき、<br />
          有償のMCDP-IDで再度ログインしていただきますようお願いいたします。
        </div>
        <br />
        <br />
        <Button
          className={styles.sysButton}
          onClick={logout}
        >
          閉じる
        </Button>
      </Content>
      <Footer />
    </Layout >
  )
}
